module.exports = __webpack_public_path__ + "static/resources-364ccdc0708c5c4285c914e327fde2a2.jpg";